import { take } from 'rxjs/operators'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Params } from '@angular/router'
import { FormacaoDuracaoModel } from '@shared/models/backend'
import { Page } from '@shared/models'

@Injectable({
  providedIn: 'root',
})
export class FormacaoDuracaoService {
  constructor(private http: HttpClient) {}

  findAllPaginated(currentFilter: Params, pageNumber: number, pageSize: number) {
    return this.http
      .get<Page<FormacaoDuracaoModel>>('/api/formacao-duracao', {
        params: this.buildParams({ currentFilter, pageNumber, pageSize }),
      })
      .pipe(take(1))
  }

  find(id: string, tipo: string) {
    return this.http.get<FormacaoDuracaoModel>(`/api/formacao-duracao/${id}/${tipo}`).pipe(take(1))
  }

  updateDuracao(formacaoDuracao: FormacaoDuracaoModel) {
    return this.http.post<FormacaoDuracaoModel>(`/api/formacao-duracao/duracao`, formacaoDuracao).pipe(take(1))
  }

  private buildParams(filter) {
    let params = new HttpParams()
    return params.append('size', filter.pageSize).append('page', filter.pageNumber).appendAll(filter.currentFilter)
  }
}
